const urlPatterns = [
    {
        regex: /youtu\.be\/([\w\-_\?&=.]+)/i,
        url: 'www.youtube.com/embed/$1',
    },
    {
        regex: /youtube\.com(.+)v=([^&]+)(&([a-z0-9&=\-_]+))?/i,
        url: 'www.youtube.com/embed/$2?$4',
    },
    {
        regex: /youtube.com\/embed\/([a-z0-9\?&=\-_]+)/i,
        url: 'www.youtube.com/embed/$1',
    },
    {
        regex: /vimeo\.com\/([0-9]+)/,
        url:
            'player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=8dc7dc',
    },
    {
        regex: /vimeo\.com\/(.*)\/([0-9]+)/,
        url: 'player.vimeo.com/video/$2?title=0&amp;byline=0',
    },
    {
        regex: /maps\.google\.([a-z]{2,3})\/maps\/(.+)msid=(.+)/,
        url: 'maps.google.com/maps/ms?msid=$2&output=embed"',
    },
    {
        regex: /dailymotion\.com\/video\/([^_]+)/,
        url: 'www.dailymotion.com/embed/video/$1',
    },
    {
        regex: /dai\.ly\/([^_]+)/,
        url: 'www.dailymotion.com/embed/video/$1',
    },
]

export function oembedReplace(html) {
    const regIframe = /<iframe[^>]+src="([^"]*)"[^>]*>[^<]*<\/iframe>/gm
    const regAll = /<figure[^>]+class="media"[^>]*>[^<]*<oembed[^>]+url="([^"]*)"[^>]*>[^<]*<\/oembed>[^<]*<\/figure>|<figure[^>]+class="media[^>]*>[^<]*<div[^>]+data-oembed[^>]*>[^<]*<div[^>]*>[^<]*<iframe[^>]+src="([^"]*)"[^>]*>[^<]*<\/iframe>[^<]*<\/div>[^<]*<\/div>[^<]*<\/figure>/gm
    if (html) {
        // html = html.replace(regAll, (match, oembedUrl, iframeUrl) => {
        //     const mediaUrl = oembedUrl ? oembedUrl : iframeUrl
        //     for (const urlPattern of urlPatterns) {
        //         const match = urlPattern.regex.exec(mediaUrl)

        //         if (match) {
        //             let newUrl = 'https://' + urlPattern.url
        //             for (let i = 0; match[i]; i++) {
        //                 newUrl = newUrl.replace('$' + i, function() {
        //                     return match[i]
        //                 })
        //             }
        //             //return `<iframe src="${newUrl}" frameborder="0" allowfullscreen></iframe>`
        //             return `<div data-oembed-url="${newUrl}"><div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.25%;"><iframe allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen="" scrolling="no" src="${newUrl}" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;" tabindex="-1"></iframe></div></div>`
        //         }
        //     }
        //     return ''
        // })
        // html = html.replace(regIframe, (match, mediaUrl) => {
        //     for (const urlPattern of urlPatterns) {
        //         const match = urlPattern.regex.exec(mediaUrl)

        //         if (match) {
        //             let newUrl = 'https://' + urlPattern.url
        //             for (let i = 0; match[i]; i++) {
        //                 newUrl = newUrl.replace('$' + i, function() {
        //                     return match[i]
        //                 })
        //             }
        //             //return `<figure class="media"><div data-oembed-url="${newUrl}"><div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="${newUrl}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div></figure>`
        //             return `<div data-oembed-url="${newUrl}"><div style="left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.25%;"><iframe allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen="" scrolling="no" src="${newUrl}" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;" tabindex="-1"></iframe></div></div>`
        //         }
        //     }
        //     return ''
        // })
    }

    return html
}
